import { classNames } from '@/shared/lib/classNames/classNames';

interface CasesTextProps {
  size: 'big' | 'medium' | 'compact' | 'small';
  children: React.ReactNode;
  className?: string;
}

export const CasesText = ({ children, size, className }: CasesTextProps) => {
  switch (size) {
    case 'big':
      return (
        <h2
          className={classNames({
            cls: 'text-text-base-primary typo-heading-l',
            additional: [className],
          })}
        >
          {children}
        </h2>
      );
    case 'medium':
      return (
        <h3
          className={classNames({
            cls: 'text-text-base-primary typo-heading-m',
            additional: [className],
          })}
        >
          {children}
        </h3>
      );
    case 'compact':
      return (
        <p
          className={classNames({
            cls: 'text-text-base-primary typo-heading-s',
            additional: [className],
          })}
        >
          {children}
        </p>
      );
    case 'small':
      return (
        <p
          className={classNames({
            cls: 'text-text-base-primary text-[16px] leading-[28px] font-normal max-sm:text-[16px] max-sm:leading-[24px]',
            additional: [className],
          })}
        >
          {children}
        </p>
      );
  }
};
